module.exports = __webpack_public_path__ + "static/img/no-data.c2309e67.png";